(function() {
  define('bazemont/event/list',['angular'], function() {
    'use strict';
    var eventsCtrl;
    eventsCtrl = function($http, $scope, BazemontEvents, TlhNotifierService, TlhCmsEvents, TlhNotificationService) {
      var cancelEventsModifications, edited, handleEditEvent, handleEventsChange, handleNewEvent, initialValue, isUpcomingEvent, saveEventsModifications, setEvents, vm;
      vm = this;
      edited = false;
      initialValue = null;
      setEvents = function(events) {
        initialValue = angular.copy(events);
        return vm.events = angular.copy(initialValue);
      };
      vm.$onInit = function() {
        $http.get('/api/user-categories', {
          cache: true
        }).then(function(response) {
          vm.categories = response.data.categories;
          return vm.isAdmin = response.data.isAdmin;
        });
        return $http.get('/api/admin/events/list').then(function(response) {
          return setEvents(response.data);
        });
      };
      isUpcomingEvent = function(event) {
        var today;
        today = new Date();
        today.setHours(0, 0, 0, 0);
        today = today.getTime();
        return !event.eventDate || new Date(event.eventDate).getTime() > today || (event.endsOn && new Date(event.endsOn).getTime() > today);
      };
      vm.upcomingEvent = function(event) {
        return event && event.isActive && isUpcomingEvent(event);
      };
      vm.pastEvent = function(event) {
        return event && event.isActive && !isUpcomingEvent(event);
      };
      saveEventsModifications = function() {
        if (edited) {
          TlhNotificationService.info({
            message: 'Enregistrement des évènements...',
            delay: false
          });
          return $http.post('/api/admin/events/save', {
            events: vm.events
          }).then(function(response) {
            setEvents(response.data);
            TlhNotifierService.send(TlhCmsEvents.SAVE_SUCCESS);
            return TlhNotificationService.success({
              message: 'Enregistrement des évènements terminé',
              replaceMessage: true
            });
          })["catch"](function(error) {
            var message;
            message = "L'enregistrement a échoué :<br>";
            message += error.data ? error.data : "Erreur inattendue lors de l'enregistrement des évènements, veuillez contacter l'administrateur.";
            TlhNotifierService.send(TlhCmsEvents.SAVE_FAILED);
            TlhNotificationService.error({
              message: message,
              replaceMessage: true,
              delay: false
            });
            return console.error(error);
          });
        }
      };
      cancelEventsModifications = function() {
        return vm.events = angular.copy(initialValue);
      };
      handleNewEvent = function(e, data) {
        return vm.events.push(data);
      };
      handleEditEvent = function(e, data) {
        return vm.events[vm.events.indexOf(data.currentEvent)] = data.editedEvent;
      };
      $scope.$on(TlhCmsEvents.SAVE_ALL, saveEventsModifications);
      $scope.$on(TlhCmsEvents.CANCEL_ALL, cancelEventsModifications);
      $scope.$on(BazemontEvents.NEW_EVENT, handleNewEvent);
      $scope.$on(BazemontEvents.EDIT_EVENT, handleEditEvent);
      handleEventsChange = function(newValue, oldValue) {
        if (newValue !== oldValue) {
          if (!edited && !angular.equals(newValue, initialValue)) {
            TlhNotifierService.send(TlhCmsEvents.PAGE_MODIFIED);
            edited = true;
          }
          if (edited && angular.equals(newValue, initialValue)) {
            TlhNotifierService.send(TlhCmsEvents.PAGE_UNMODIFIED);
            return edited = false;
          }
        }
      };
      $scope.$watch(function() {
        return vm.events;
      }, handleEventsChange, true);
    };
    eventsCtrl.$inject = ['$http', '$scope', 'BazemontEvents', 'TlhNotifierService', 'TlhCmsEvents', 'TlhNotificationService'];
    return angular.module('bazemontEventList', []).component('bazemontEventList', {
      templateUrl: '/assets/javascripts/bazemont/event/list.html',
      controller: eventsCtrl,
      bindings: {
        year: '@'
      }
    }).component('bazemontEventListHome', {
      templateUrl: '/assets/javascripts/bazemont/event/list-home.html',
      controller: eventsCtrl
    });
  });

}).call(this);

//# sourceMappingURL=list.js.map
;
